module.exports = __webpack_public_path__ + "img/managing_rewards.637963cf.png";